module.exports = __webpack_public_path__ + "img/job--seeker.0aa060fd.svg";